<template>
  <v-content class="d-flex" style="overflow: hidden;">
    <v-container fluid class="pa-0" lg="2">
      <v-row class="ma-0">
        <v-col
          id="carousel"
          class="pa-0"
          style="width: calc(100% - 150px); height: 100vh;"
        >
          <v-carousel
            v-if="
              elective &&
                elective.reports.length > 0 &&
                (elective.reports[0].status === 'S' ||
                  elective.reports[0].status === 'Re')
            "
            v-model="carouselIndex"
            hide-delimiters
            height="100vh"
            id="wrapper"
            :show-arrows="false"
            :touchless="true"
            style="background: #3d3c3c; overflow: auto"
          >
            <v-btn
              fab
              small
              @click="preSlide"
              style="position: absolute; top: 50%; left: 1%; z-index: 999"
            >
              <v-icon dark>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              fab
              small
              @click="nextSlide"
              style="position: absolute; top: 50%; right: 1%; z-index: 999"
            >
              <v-icon dark>mdi-chevron-right</v-icon>
            </v-btn>
            <v-overlay v-if="canvasLoading" absolute opacity="100">
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
            <v-carousel-item
              v-for="(report, index) in reports"
              ref="carousels"
              :key="`canvas-${index}`"
              class="carousel-item"
              eager
            >
              <div
                :id="`scroll-${index}`"
                class="v-responsive v-image v-carousel__item vb-content"
                style="
                  display: flex;
                  overflow: auto;
                  height: 100%;
                  width: calc(100% + 17px);
                "
              >
                <div class="v-responsive__content">
                  <canvas :id="`canvas-${index}`"></canvas>
                </div>
              </div>
            </v-carousel-item>
          </v-carousel>
          <v-carousel
            v-else-if="
              elective.reports.length > 0 && elective.reports[0].status === 'Y'
            "
            v-model="carouselIndex"
            hide-delimiters
            height="100vh"
            id="wrapper"
            :touchless="true"
            style="background: #3d3c3c"
          >
            <v-carousel-item
              v-for="(report, index) in reports"
              ref="carousels"
              :key="`canvas-${index}`"
              class="carousel-item"
            >
              <div
                class="v-responsive v-image v-carousel__item vb-content"
                style="
                  display: block;
                  overflow: hidden scroll;
                  height: 100%;
                  width: calc(100% + 17px);
                "
              >
                <div class="v-responsive__content">
                  <img
                    style="position: absolute; width: 100%"
                    :src="reports[index]"
                  />
                </div>
              </div>
            </v-carousel-item>
          </v-carousel>
          <v-carousel
            v-else-if="
              elective.reports.length > 0 &&
                (elective.reports[0].status === 'C' ||
                  elective.reports[0].status === 'Draft')
            "
            v-model="carouselIndex"
            hide-delimiters
            height="100vh"
            id="wrapper"
            :touchless="true"
            style="background: #3d3c3c"
          >
            <v-carousel-item
              v-for="(report, index) in checkReports"
              ref="carousels"
              :key="`canvas-${index}`"
              class="carousel-item"
            >
              <div
                class="v-responsive v-image v-carousel__item vb-content"
                style="
                  display: block;
                  overflow: hidden scroll;
                  height: 100%;
                  width: calc(100% + 17px);
                "
              >
                <div class="v-responsive__content">
                  <img
                    style="position: absolute; width: 100%"
                    :src="reports[index]"
                  />
                  <img
                    style="position: absolute; width: 100%"
                    v-if="
                      elective.reports.length > 0 &&
                        (elective.reports[0].status === 'C' ||
                          elective.reports[0].status === 'Draft')
                    "
                    :src="checkReports[index]"
                  />
                </div>
              </div>
            </v-carousel-item>
          </v-carousel>
          <v-card class="menu_style" style="visibility: hidden; width: 300px">
            <v-card-actions class="d-flex flex-wrap justify-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    class="mr-1 mb-1 ml-1"
                    v-on="on"
                    @click.stop="drawClick('smallright')"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>正确</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    class="mr-1 mb-1 ml-1"
                    v-on="on"
                    @click.stop="drawClick('pen')"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>画笔</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    class="mr-1 mb-1 ml-1"
                    v-on="on"
                    @click.stop="drawClick('arrow')"
                  >
                    <v-icon>mdi-arrow-top-right</v-icon>
                  </v-btn>
                </template>
                <span>箭头</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                    class="mr-1 mb-1 ml-1"
                    v-on="on"
                    @click.stop="drawClick('rectangle')"
                  >
                    <v-icon>mdi-vector-rectangle</v-icon>
                  </v-btn>
                </template>
                <span>矩形</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    color="red"
                    class="mr-1 mb-1 ml-1"
                    v-on="on"
                    @click.stop="drawClick('remove')"
                  >
                    <v-icon>mdi-eraser</v-icon>
                  </v-btn>
                </template>
                <span>擦除</span>
              </v-tooltip>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text class="pa-0 px-1">
              <v-list class="pa-0">
                <v-list-item-group>
                  <template v-for="(item, index) in filterDeductionHistory">
                    <v-tooltip :key="`t-${index}`" right class="pa-0">
                      <template v-slot:activator="{ on }">
                        <v-list-item
                          :key="`l-${index}`"
                          @click="selected(item.deduction)"
                          class="pa-0"
                          dense
                          inactive
                          v-on="on"
                        >
                          <v-list-item-action-text>
                            <v-btn-toggle
                              v-if="item.deduction.check_mark === 'error'"
                              v-model="item.deduction.score"
                              class="d-inline mt-1"
                              mandatory
                            >
                              <v-btn
                                v-for="(score, index) in item.deduction.scores"
                                :key="index"
                                :value="score"
                                active-class="red white--text"
                                style="color: rgba(0, 0, 0, 1)"
                                x-small
                                @click="hideMenu"
                              >
                                {{ score }}
                              </v-btn>
                            </v-btn-toggle>
                            <v-btn-toggle
                              v-else-if="item.deduction.check_mark === 'right'"
                              v-model="item.deduction.score"
                              class="d-inline mt-1"
                              mandatory
                            >
                              <v-btn
                                v-for="(score, index) in item.deduction.scores"
                                :key="index"
                                :value="score"
                                active-class="green white--text"
                                style="color: rgba(0, 0, 0, 1)"
                                x-small
                                @click="hideMenu"
                              >
                                {{ score }}
                              </v-btn>
                            </v-btn-toggle>
                            <v-btn-toggle
                              v-else
                              v-model="item.deduction.score"
                              class="d-inline mt-1"
                              mandatory
                            >
                              <v-btn
                                v-for="(score, index) in item.deduction.scores"
                                :key="index"
                                :value="score"
                                active-class="orange white--text"
                                style="color: rgba(0, 0, 0, 1)"
                                x-small
                                @click="hideMenu"
                              >
                                {{ score }}
                              </v-btn>
                            </v-btn-toggle>
                            <span
                              v-if="item.deduction.check_mark === 'right'"
                              style="font-size: 0.9rem"
                            >
                              {{ item.deduction.comment }}
                            </span>
                            <span
                              v-else-if="
                                item.deduction.check_mark === 'half_error'
                              "
                              style="font-size: 0.9rem"
                            >
                              {{ item.deduction.comment }}
                            </span>
                            <span v-else style="font-size: 0.9rem">
                              {{ item.deduction.comment }}
                            </span>
                          </v-list-item-action-text>
                        </v-list-item>
                        <v-divider :key="`d-${index}`"></v-divider>
                      </template>
                      <div>
                        <p class="ma-0">分类: {{ item.deduction.type }}</p>
                        <p class="ma-0">
                          类型: {{ item.deduction.dicts.dictvalue }}
                        </p>
                        <p v-if="item.deduction.tip" class="ma-0">
                          批改提示: {{ item.deduction.tip }}
                        </p>
                      </div>
                    </v-tooltip>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="py-0 px-1">
              <template v-for="(type, index) in deductions">
                <v-menu :key="`ty-${index}`" offset-x bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-if="type[1].length"
                      v-on="on"
                      v-bind="attrs"
                      small
                      class="my-1 mr-1"
                    >
                      {{ type[0] }}
                    </v-chip>
                  </template>
                  <v-list v-if="type[1].length">
                    <v-list-item-group>
                      <template v-for="(item, index) in type[1]">
                        <v-list-item
                          :key="`deduct-${index}`"
                          @click="selected(item)"
                          dense
                          inactive
                        >
                          <v-list-item-content class="py-1">
                            <v-list-item-subtitle
                              class="black--text"
                              style="white-space: normal"
                              v-text="
                                `NO.${item.display_order}: ${item.comment}`
                              "
                            ></v-list-item-subtitle>
                            <v-list-item-action-text
                              class="pt-1 primary--text"
                              style="font-size: 0.9rem"
                            >
                              {{ item.tip }}
                            </v-list-item-action-text>
                            <v-list-item-action-text
                              v-if="item.check_mark === 'error'"
                              class="pt-1"
                            >
                              <v-btn-toggle
                                v-model="item.score"
                                class="d-inline mt-1"
                                mandatory
                              >
                                <v-btn
                                  v-for="(score, index) in item.scores"
                                  :key="index"
                                  :value="score"
                                  active-class="red white--text"
                                  style="color: rgba(0, 0, 0, 1)"
                                  x-small
                                  @click="hideMenu"
                                >
                                  {{ score }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-list-item-action-text>
                            <v-list-item-action-text
                              v-else-if="item.check_mark === 'right'"
                              class="pt-1"
                            >
                              <v-btn-toggle
                                v-model="item.score"
                                class="d-inline mt-1"
                                mandatory
                              >
                                <v-btn
                                  v-for="(score, index) in item.scores"
                                  :key="index"
                                  :value="score"
                                  active-class="green white--text"
                                  style="color: rgba(0, 0, 0, 1)"
                                  x-small
                                  @click="hideMenu"
                                >
                                  {{ score }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-list-item-action-text>
                            <v-list-item-action-text v-else class="pt-1">
                              <v-btn-toggle
                                v-model="item.score"
                                class="d-inline mt-1"
                                mandatory
                              >
                                <v-btn
                                  v-for="(score, index) in item.scores"
                                  :key="index"
                                  :value="score"
                                  active-class="orange white--text"
                                  style="color: rgba(0, 0, 0, 1)"
                                  x-small
                                  @click="hideMenu"
                                >
                                  {{ score }}
                                </v-btn>
                              </v-btn-toggle>
                            </v-list-item-action-text>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider :key="index"></v-divider>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </template>
            </v-card-text>
          </v-card>
          <color-picker
            v-if="showColorPicker"
            position="absolute"
            :top="505"
            :right="102"
            :rightOffset="38"
            @pickColor="setColor"
          ></color-picker>
        </v-col>
        <v-col
          class="pa-0 text-center d-flex"
          style="position: relative; max-width: 100px"
        >
          <div
            class="v-navigation-drawer__border"
            style="background-color: rgba(0, 0, 0, 0.12); left: 0"
          ></div>
          <v-container
            style="height: 100vh"
            class="pa-0 d-flex flex-column justify-space-between"
          >
            <v-card class="report-height" v-if="elective">
              <v-system-bar lights-out>
                <v-icon>mdi-account</v-icon>
                <span v-if="curDrawerType === 'schedule'">
                  {{ elective.users.name }}
                </span>
                <span v-else-if="curDrawerType === 'student'">
                  {{ elective.user_name }}
                </span>
              </v-system-bar>
              <v-system-bar lights-out>
                <v-icon>mdi-menu</v-icon>
                <span
                  v-if="
                    elective.reports.length > 0 &&
                      (elective.reports[0].status === 'C' ||
                        elective.reports[0].status === 'Y')
                  "
                  >已批阅</span
                >
                <span
                  v-else-if="
                    elective.reports.length > 0 &&
                      elective.reports[0].status === 'S'
                  "
                  >待批阅</span
                >
                <span
                  v-else-if="
                    elective.reports.length > 0 &&
                      elective.reports[0].status === 'Draft'
                  "
                  >草稿</span
                >
                <span v-else>未提交</span>
              </v-system-bar>
              <v-system-bar lights-out>
                <v-icon>mdi-check</v-icon>
                <span
                  v-if="
                    elective.reports.length > 0 &&
                      elective.reports[0].status === 'Y'
                  "
                  >等级: {{ elective.reports[0].grade }}</span
                >
                <span
                  v-if="
                    showGrade &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'S'
                  "
                  >{{ grade }}分</span
                >
                <span
                  v-if="
                    elective.reports.length > 0 &&
                      (elective.reports[0].status === 'C' ||
                        elective.reports[0].status === 'Draft')
                  "
                  >{{
                    elective.project_score
                      ? elective.project_score.report_score
                      : 0
                  }}分</span
                >
              </v-system-bar>
              <v-card-actions class="pa-0 pb-1 d-flex flex-column align-start">
                <v-btn
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule') ||
                      (user.role === 'assistant' && config.assistantCommit)) &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'S'
                  "
                  small
                  class="ma-0 mb-1 ml-1"
                  color="primary"
                  @click="checkComplete('submit')"
                >
                  提交
                </v-btn>
                <v-btn
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule') ||
                      (user.role === 'assistant' && config.assistantCommit)) &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'Draft'
                  "
                  small
                  class="ma-0 mb-1 ml-1"
                  color="primary"
                  @click="submit"
                >
                  提交
                </v-btn>
                <v-btn
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule') ||
                      user.role === 'assistant') &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'S'
                  "
                  small
                  class="ma-0 mb-1 ml-1"
                  color="error"
                  @click="sendback"
                >
                  退回
                </v-btn>
                <v-btn
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule') ||
                      user.role === 'assistant') &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'Re'
                  "
                  small
                  class="ma-0 mb-1 ml-1"
                  color="error"
                  @click="revertSendback"
                >
                  撤销退回
                </v-btn>
                <v-btn
                  v-if="
                    (user.role === 'assistant' &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'Draft') ||
                      (user.role === 'assistant' &&
                        elective.reports.length > 0 &&
                        elective.users.code === user.code &&
                        elective.reports[0].status === 'C')
                  "
                  small
                  class="ma-0 mb-1 ml-1"
                  color="error"
                  @click="reCheck"
                >
                  重改
                </v-btn>
                <v-btn
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule')) &&
                      elective.reports.length > 0 &&
                      (elective.reports[0].status === 'C' ||
                        elective.reports[0].status === 'Draft')
                  "
                  small
                  class="ma-0 mb-1 ml-1"
                  color="error"
                  @click="reCheck"
                >
                  重改
                </v-btn>
                <v-btn
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule') ||
                      user.role === 'assistant') &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'S'
                  "
                  small
                  class="ma-0 ml-1"
                  color="primary"
                  @click="checkComplete('saveDraft')"
                >
                  存草稿
                </v-btn>
                <v-row
                  v-if="
                    (user.role === 'centreadmin' ||
                      (user.role === 'teacher' &&
                        elective.schedules &&
                        user.id === elective.schedules.teacher_id) ||
                      (user.role === 'teacher' &&
                        elective.schedule_status === 'free_schedule') ||
                      (user.role === 'assistant' &&
                        config.assistantQuiceDeduction)) &&
                      elective.reports.length > 0 &&
                      elective.reports[0].status === 'S'
                  "
                  class="mx-1 mt-5"
                >
                  <v-text-field
                    v-model="quickDeduction"
                    class="ma-0 pa-0"
                    style="width: 55px"
                    type="number"
                    hide-details
                    dense
                    label="快捷评分"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        class="px-0 mt-3"
                        x-small
                        color="primary"
                        @click="checkComplete('quick')"
                      >
                        <v-icon>mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span>提交评分</span>
                  </v-tooltip>
                </v-row>
                <v-btn
                  v-if="!histories.length"
                  small
                  class="ma-1 ml-1"
                  color="primary"
                  @click="viewHistory()"
                >
                  历史回溯
                </v-btn>
                <v-btn
                  v-if="histories.length && !ending"
                  small
                  class="ma-1 ml-1"
                  color="primary"
                  @click="nextHistory()"
                >
                  上一条
                </v-btn>
                <v-btn
                  v-if="histories.length && ((curNum && !offset) || offset)"
                  small
                  class="ma-1 ml-1"
                  color="primary"
                  @click="previousHistory()"
                >
                  下一条
                </v-btn>
                <v-btn
                  v-if="histories.length"
                  small
                  class="ma-1 ml-1"
                  color="primary"
                  @click="quitHistory()"
                >
                  返回
                </v-btn>
              </v-card-actions>
            </v-card>
            <div
              v-if="
                (user.role === 'centreadmin' ||
                  (user.role === 'teacher' &&
                    elective.schedules &&
                    user.id === elective.schedules.teacher_id) ||
                  (user.role === 'teacher' &&
                    elective.schedule_status === 'free_schedule') ||
                  user.role === 'assistant') &&
                  elective.reports.length > 0 &&
                  elective.reports[0].status === 'S'
              "
              class="d-flex flex-column justify-center"
            >
              <div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('smallright')"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>正确</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('right')"
                    >
                      <v-icon>mdi-check-all</v-icon>
                    </v-btn>
                  </template>
                  <span>全对</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      style="font-size: 25px;"
                      @click.stop="drawClick('halfError')"
                    >
                      ⍻
                    </v-btn>
                  </template>
                  <span>半对</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('error')"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>错误</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('pen')"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>画笔</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('text')"
                    >
                      <v-icon>mdi-format-text</v-icon>
                    </v-btn>
                  </template>
                  <span>文本</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('line')"
                    >
                      <v-icon>mdi-vector-line</v-icon>
                    </v-btn>
                  </template>
                  <span>直线</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('arrow')"
                    >
                      <v-icon>mdi-arrow-top-right</v-icon>
                    </v-btn>
                  </template>
                  <span>箭头</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('rectangle')"
                    >
                      <v-icon>mdi-vector-rectangle</v-icon>
                    </v-btn>
                  </template>
                  <span>矩形</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('ellipse')"
                    >
                      <v-icon>mdi-ellipse-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>椭圆</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('triangle')"
                    >
                      <v-icon>mdi-triangle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>正三角形</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('questionmark')"
                    >
                      <v-icon>mdi-help</v-icon>
                    </v-btn>
                  </template>
                  <span>问号</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('appendMark')"
                    >
                      <img
                        src="../assets/svg/appendMark.svg"
                        width="40"
                        height="40"
                      />
                    </v-btn>
                  </template>
                  <span>增补号</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('removeMark')"
                    >
                      <img
                        src="../assets/svg/removeMark.svg"
                        width="40"
                        height="40"
                      />
                    </v-btn>
                  </template>
                  <span>删除号</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="rotate"
                    >
                      <v-icon>mdi-rotate-right</v-icon>
                    </v-btn>
                  </template>
                  <span>旋转</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="zoom(-0.1)"
                    >
                      <v-icon>mdi-magnify-minus-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>缩小</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="green"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="zoom(0.1)"
                    >
                      <v-icon>mdi-magnify-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>放大</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="undo()"
                    >
                      <v-icon>mdi-undo-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>撤销</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="redo()"
                    >
                      <v-icon>mdi-redo-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>重做</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="drawClick('remove')"
                    >
                      <v-icon>mdi-eraser</v-icon>
                    </v-btn>
                  </template>
                  <span>擦除</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      color="red"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="removeAll"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>清空批阅记录</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      dark
                      small
                      :color="shapeColor"
                      class="mr-1 mb-1 ml-1"
                      v-on="on"
                      @click.stop="toggleColorPicker"
                    >
                      <v-icon>mdi-palette</v-icon>
                    </v-btn>
                  </template>
                  <span>颜色</span>
                </v-tooltip>
              </div>
            </div>
            <div class="ma-0">
              <v-chip
                style="width: 100px"
                class="pa-0 justify-center"
                color="primary"
                label
              >
                {{ this.carouselIndex + 1 }} / {{ this.reports.length }}
              </v-chip>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { fabric } from 'fabric';
import { mapActions, mapGetters } from 'vuex';

import 'fabric-history';
import api from '../tianmuhu/api';
import ColorPicker from './ColorPicker';

export default {
  inject: ['reload'],
  data() {
    return {
      grade: 100,
      quickDeduction: 100,
      carouselIndex: 0,
      screenAspectRadio: 1,
      screenWidth: 0,
      screenHeight: 0,
      loadings: [],
      counts: 0,
      showGrade: false,
      backgroundImages: [],
      // draw staff
      drawType: '',
      mouseFrom: {},
      mouseTo: {},
      textblock: null,
      drawingObject: null,
      drawingItext: null,
      doDrawing: false,
      moveCount: 1,
      deductScores: [], // 批改每页报告的分数
      rotateTimes: [],
      canvasArray: [],
      coefficient: 650 / 1080, // 原系统默认比例
      canvasLoading: false,
      layer_data: null,
      shapeColor: '#FF0000',
      showColorPicker: false,
      initialDistance: 0
    };
  },
  components: { ColorPicker },
  computed: {
    ...mapGetters([
      'config',
      'user',
      'elective',
      'electives',
      'selectedLessons',
      'reports',
      'checkReports',
      'hangingDrawdeduction',
      'deductions',
      'deductionTypes',
      'expandDrawer',
      'lessons',
      'lessonOptions',
      'studentOptions',
      'orgOptions',
      'deductionHistory',
      'curDrawerType',
      'isOrg',
      'histories',
      'originalU2p',
      'originalSchedule',
      'curNum',
      'limit',
      'offset',
      'ending'
    ]),
    filterDeductionHistory() {
      return this.deductionHistory
        .filter(item => {
          return this.deductions
            .reduce((pre, cur) => pre.concat(cur[1]), [])
            .some(i => i.id === item.deduction.id);
        })
        .sort((a, b) => b.count - a.count)
        .slice(0, 5);
    }
  },
  watch: {
    shapeColor(color) {
      for (let i = 0; i < this.reports.length; i++) {
        this.canvasArray[i].canvas.freeDrawingBrush.color = color;
      }
    },
    carouselIndex(index) {
      this.$store.commit('setCurCanvasIndex', index);
      this.canvasLoading = this.loadings[index];
    },
    loadings(val) {
      this.canvasLoading = val[this.carouselIndex];
    },
    hangingDrawdeduction(deduction) {
      if (deduction) {
        this.drawClick('wrong');
      }
    }
  },
  mounted() {
    this.$store.commit('setHangingDrawdeduction', null);
    this.changeSelectedItem(null);
    this.addDeductionHistory();
    this.layer_data = null;
    this.backgroundImages = [];

    for (let i = 0; i < this.reports.length; i++) {
      this.deductScores[i] = 0;

      const carouselId = document.getElementById(`canvas-${i}`);
      if (carouselId) this.render(i);
    }

    this.createClass();

    this.$nextTick(() => {
      let wrapper = document.querySelector('#wrapper');
      this.screenWidth = wrapper.clientWidth;
      this.screenHeight = wrapper.clientHeight;
      window.onresize = () => {
        this.changeScreenSize();
      };
      // let el = document.querySelector('.canvas-container');
      // if (!el) {
      //   this.render(this.carouselIndex);
      // }
    });

    const throttle = (preSlide, nextSlide, zoom, limit) => {
      let inThrottle = false;

      return function(e) {
        if (e.type === 'wheel') {
          if (e.ctrlKey || e.shiftKey) e.preventDefault();

          if (!inThrottle) {
            if (e.ctrlKey && e.deltaY > 0) zoom(-0.1);
            else if (e.ctrlKey && e.deltaY < 0) zoom(0.1);
            else if (e.shiftKey && e.deltaY > 0) preSlide();
            else if (e.shiftKey && e.deltaY < 0) nextSlide();

            inThrottle = true;

            setTimeout(() => {
              inThrottle = false;
            }, limit);
          }
        } else if (e.type === 'touchmove') {
          e.preventDefault();

          if (!inThrottle && e.touches.length === 2) {
            const finalDistance = calculateDistance(e.touches[0], e.touches[1]);

            if (finalDistance > this.initialDistance) {
              this.zoom(0.1);
            } else if (this.initialDistance < finalDistance) {
              this.zoom(-0.1);
            }

            inThrottle = true;

            setTimeout(() => {
              inThrottle = false;
            }, limit);
          }
        }
      };
    };

    document.addEventListener('keyup', event => {
      if (!event.ctrlKey) return;
      else if (event.key === 'z') this.undo();
      else if (event.key === 'y') this.redo();
    });

    document.addEventListener('touchstart', e => {
      if (e.touches.length === 2) {
        this.initialDistance = calculateDistance(e.touches[0], e.touches[1]);
      }
    });

    document.addEventListener(
      'touchmove',
      throttle(null, null, this.zoom, 500)
    );

    const carousel = document.querySelector('#carousel');

    carousel.addEventListener(
      'wheel',
      throttle(this.preSlide, this.nextSlide, this.zoom, 500)
    );
  },
  methods: {
    ...mapActions([
      'rotateReport',
      'updateReport',
      'updateReportStatus',
      'deduct',
      'changeElective',
      'reloadElective',
      'alert',
      'selectLessons',
      'fetchLessons',
      'fetchStudents',
      'afterFetchStudents',
      'fetchOrgs',
      'afterFetchOrgs',
      'hangupDrawDeduction',
      'addDeductionHistory',
      'changeSelectedItem',
      'sendbackReport'
    ]),
    hideMenu() {
      let menu = document.querySelector('.menu_style');

      if (menu.style.visibility === 'visible') {
        menu.style = 'visibility: hidden; width: 300px;';
      }
    },
    nextSlide() {
      this.carouselIndex = (this.carouselIndex + 1) % this.reports.length;
    },
    preSlide() {
      this.carouselIndex =
        this.carouselIndex - 1 < 0
          ? this.reports.length - 1
          : this.carouselIndex - 1;
    },
    selected(deduction) {
      let menu = document.querySelector('.menu_style');

      if (menu.style.visibility === 'visible') {
        menu.style = 'visibility: hidden; width: 300px;';
      }

      this.hangupDrawDeduction(deduction);
    },
    computedOffset(options) {
      let menu = document.querySelector('.menu_style');
      let scroll = document.querySelector(`#scroll-${this.carouselIndex}`);
      let container = document.querySelector(`#canvas-${this.carouselIndex}`)
        .parentNode;

      // 判断是否有空白偏移
      let offsetH =
        scroll.clientWidth > container.clientWidth
          ? (scroll.clientWidth - container.clientWidth) / 2
          : 0;
      let offsetV =
        scroll.clientHeight > container.clientHeight
          ? (scroll.clientHeight - container.clientHeight) / 2
          : 0;

      // 水平方向滚动偏移, 垂直方向滚动偏移
      if (
        scroll.clientHeight < scroll.scrollHeight &&
        scroll.clientWidth < scroll.scrollWidth
      ) {
        if (
          options.pointer.y - scroll.scrollTop + menu.clientHeight >
            scroll.clientHeight &&
          options.pointer.x - scroll.scrollLeft + menu.clientWidth >
            scroll.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else if (
          options.pointer.y - scroll.scrollTop + menu.clientHeight >
          scroll.clientHeight
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH +
            10}px; width: 300px;`;
        } else if (
          options.pointer.x - scroll.scrollLeft + menu.clientWidth >
          scroll.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft +
            10}px; width: 300px;`;
        }
        // 垂直方向滚动偏移
      } else if (scroll.clientHeight < scroll.scrollHeight) {
        if (
          options.pointer.y - scroll.scrollTop + menu.clientHeight >
            scroll.clientHeight &&
          options.pointer.x + menu.clientWidth > container.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else if (
          options.pointer.y - scroll.scrollTop + menu.clientHeight >
          scroll.clientHeight
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH +
            10}px; width: 300px;`;
        } else if (
          options.pointer.x + menu.clientWidth >
          container.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop}px; left: ${options.pointer.x +
            offsetH -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            scroll.scrollTop}px; left: ${options.pointer.x +
            offsetH +
            10}px; width: 300px;`;
        }
        // 水平方向滚动偏移
      } else if (scroll.clientWidth < scroll.scrollWidth) {
        if (
          options.pointer.y + menu.clientHeight > container.clientHeight &&
          options.pointer.x - scroll.scrollLeft + menu.clientWidth >
            scroll.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else if (
          options.pointer.y + menu.clientHeight >
          container.clientHeight
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft +
            10}px; width: 300px;`;
        } else if (
          options.pointer.x - scroll.scrollLeft + menu.clientWidth >
          scroll.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y + offsetV}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y + offsetV}px; left: ${options.pointer.x +
            offsetH -
            scroll.scrollLeft +
            10}px; width: 300px;`;
        }
        // 无滚动
      } else {
        if (
          options.pointer.y + menu.clientHeight > container.clientHeight &&
          options.pointer.x + menu.clientWidth > container.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else if (
          options.pointer.y + menu.clientHeight >
          container.clientHeight
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y +
            offsetV -
            menu.clientHeight}px; left: ${options.pointer.x +
            offsetH +
            10}px; width: 300px;`;
        } else if (
          options.pointer.x + menu.clientWidth >
          container.clientWidth
        ) {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y + offsetV}px; left: ${options.pointer.x +
            offsetH -
            10 -
            menu.clientWidth}px; width: 300px;`;
        } else {
          menu.style = `visibility: visible; position: absolute; top: ${options
            .pointer.y + offsetV}px; left: ${options.pointer.x +
            offsetH +
            10}px; width: 300px;`;
        }
      }
    },
    // 自定义 fabric.js 类型
    createClass() {
      // 自定义 deduction 类型, 用于生成评分参考图案
      fabric.Deduction = fabric.util.createClass(
        fabric.Group,
        {
          type: 'deduction',
          initialize: function(objects, options) {
            this.callSuper('initialize', objects, options);
            options &&
              this.set({ eindex: options.eindex, score: options.score });
          },
          toObject: function(propertiesToInclude) {
            propertiesToInclude = (propertiesToInclude || []).concat(['eindex', 'score']);
            var obj = this.callSuper('toObject', propertiesToInclude);
            return obj;
          }
        }
      );

      fabric.Deduction.fromObject = function(object, callback) {
        let objects = object.objects;
        let options = fabric.util.object.clone(object, true);
        delete options.objects;

        fabric.util.enlivenObjects(objects, function(enlivenedObjects) {
          let options = fabric.util.object.clone(object, true);
          delete options.objects;

          fabric.util.enlivenObjectEnlivables(object, options, function() {
            callback &&
              callback(new fabric.Deduction(enlivenedObjects, options));
          });
        });
      };

      fabric.Deduction.async = true;
    },
    changeScreenSize() {
      // const _this = this;
      // this.$nextTick(() => {
      //   _this.render(_this.carouselIndex);
      // });
    },
    render(index) {
      if (!this.elective) {
        return;
      }
      if (
        this.elective.reports.length > 0 &&
        this.elective.reports[0].status !== 'S' &&
        this.elective.reports[0].status !== 'Re'
      ) {
        return;
      }
      if (!this.reports || this.reports.length === 0) {
        return;
      }

      // 检查是否已有画布，如果是序列化的字符串则反序列化
      if (this.canvasArray[index] && typeof this.canvasArray[index].canvas === 'string') {
        try {
          const canvas = new fabric.Canvas(`canvas-${index}`, {
            crossOrigin: 'anonymous',
            isDrawingMode: false,
            skipTargetFind: true,
            selection: false,
            fireRightClick: true,
            stopContextMenu: true,
            allowTouchScrolling: true,
            originX: 'left',
            originY: 'top'
          });

          const json = JSON.parse(this.canvasArray[index].canvas);
          canvas.loadFromJSON(json, () => {
            canvas.renderAll();
            // 更新 canvasArray 中的 canvas 对象
            this.$set(this.canvasArray, index, {
              ...this.canvasArray[index],
              canvas: canvas
            });
          });
        } catch (error) {
          console.error('Canvas deserialization failed:', error);
        }
        return;
      }

      // 已经创建的画布不用重新创建
      if (this.canvasArray[index]) {
        return;
      }

      this.$set(this.loadings, index, true);

      setTimeout(() => {
        let canvas = new fabric.Canvas(`canvas-${index}`, {
          crossOrigin: 'anonymous',
          isDrawingMode: false,
          skipTargetFind: true,
          selection: false,
          fireRightClick: true,
          stopContextMenu: true,
          allowTouchScrolling: true,
          originX: 'left',
          originY: 'top'
        });

        canvas.freeDrawingBrush.color = this.shapeColor; //设置自由绘颜色
        canvas.freeDrawingBrush.width = 2;

        this.bindEvents(canvas);

        if (this.layer_data) {
          this.drawProcess({ index, layer_data: this.layer_data, canvas });
        } else {
          api.getDrawprocess(this.elective.id, drawProcess => {
            // 有批改记录则先重绘批改记录
            if (drawProcess.length && drawProcess[0].layer_data.length) {
              this.layer_data = drawProcess[0].layer_data;
              this.drawProcess({
                index,
                layer_data: this.layer_data,
                canvas
              });
              // 无批改记录则建立新 canvas
            } else this.drawProcess({ index, canvas });
          });
        }
      }, 1);
    },
    bindEvents(canvas) {
      const _this = this;
      canvas.on('mouse:down', options => {
        // 鼠标左键
        if (options.button === 1) {
          if (options.e instanceof MouseEvent) {
            _this.mouseFrom.x =
              options.e.offsetX / _this.canvasArray[_this.carouselIndex].ratio;
            _this.mouseFrom.y =
              options.e.offsetY / _this.canvasArray[_this.carouselIndex].ratio;
          } else if (options.e instanceof TouchEvent) {
            _this.mouseFrom.x =
              options.pointer.x / _this.canvasArray[_this.carouselIndex].ratio;
            _this.mouseFrom.y =
              options.pointer.y / _this.canvasArray[_this.carouselIndex].ratio;
          }

          let menu = document.querySelector('.menu_style');
          menu.style = 'visibility: hidden; width: 300px;';

          if (
            _this.drawType === 'line' ||
            _this.drawType === 'arrow' ||
            _this.drawType === 'rectangle' ||
            _this.drawType === 'ellipse' ||
            _this.drawType === 'triangle' ||
            _this.drawType === 'appendMark' ||
            _this.drawType === 'removeMark'
          ) {
            _this.canvasArray[_this.carouselIndex].canvas.offHistory();
            _this.doDrawing = true;
          }
          // 鼠标右键
        } else if (options.button === 3) {
          this.computedOffset(options);
        }
      });
      canvas.on('mouse:up', options => {
        if (options.button === 1) {
          if (options.e instanceof MouseEvent) {
            _this.mouseTo.x =
              options.e.offsetX / _this.canvasArray[_this.carouselIndex].ratio;
            _this.mouseTo.y =
              options.e.offsetY / _this.canvasArray[_this.carouselIndex].ratio;
          } else if (options.e instanceof TouchEvent) {
            _this.mouseTo.x =
              options.pointer.x / _this.canvasArray[_this.carouselIndex].ratio;
            _this.mouseTo.y =
              options.pointer.y / _this.canvasArray[_this.carouselIndex].ratio;
          }

          _this.drawing();
          _this.drawingObject = null;
          _this.drawingItext = null;
          _this.doDrawing = false;
          _this.moveCount = 1;

          if (_this.canvasArray[_this.carouselIndex].canvas.historyProcessing)
            _this.canvasArray[_this.carouselIndex].canvas.onHistory();

          let rotated = _this.canvasArray.some(x => x.rotateTimes % 4 != 0);

          if (rotated) {
            let rotateTimes = _this.canvasArray.map(palette => {
              return palette.rotateTimes;
            });

            _this
              .rotateReport({
                id: _this.elective.id,
                rotateTimes: rotateTimes
              })
              .then(() => {
                _this.canvasArray = _this.canvasArray.map(item => {
                  return {
                    ...item,
                    rotateTimes: 0
                  };
                });
                _this.updateDrawProcess(true, rotateTimes);
              });
          } else {
            _this.updateDrawProcess();
          }
        }
      });
      canvas.on('mouse:move', function(options) {
        if (_this.moveCount % 2 && !_this.doDrawing) {
          return;
        }

        if (_this.doDrawing) {
          if (options.e instanceof MouseEvent) {
            _this.mouseTo.x =
              options.e.offsetX / _this.canvasArray[_this.carouselIndex].ratio;
            _this.mouseTo.y =
              options.e.offsetY / _this.canvasArray[_this.carouselIndex].ratio;
          } else if (options.e instanceof TouchEvent) {
            _this.mouseTo.x =
              options.pointer.x / _this.canvasArray[_this.carouselIndex].ratio;
            _this.mouseTo.y =
              options.pointer.y / _this.canvasArray[_this.carouselIndex].ratio;
          }

          _this.moveCount++;
          _this.drawing();
        }
      });
      canvas.on('selection:created', function(options) {
        if (_this.drawType === 'remove') {
          options.selected.forEach(item => {
            if (item.type === 'deduction') {
              _this.grade -= item.score;
              _this.deductScores[_this.carouselIndex] -= item.score;
            }

            canvas.remove(item);
            canvas.discardActiveObject();
          });
        }
      });
    },
    /**
     * 如果有待批阅的切换到待批阅报告, 否则更新当前报告视图
     */
    next() {
      const hasNext = this.electives.some(g => {
        let nextS = g.electives.find(
          e => e.reports[0] && e.reports[0].status === 'S'
        );

        if (nextS) {
          this.changeElective(nextS);

          return true;
        } else {
          let nextDraft = g.electives.find(
            e => e.reports[0] && e.reports[0].status === 'Draft'
          );

          if (nextDraft) {
            this.changeElective(nextDraft);

            return true;
          }
        }
      });

      if (!hasNext) {
        this.reloadElective();
        this.reload();
      }
    },
    // 批阅操作
    // 退回
    sendback() {
      this.sendbackReport(this.canvasArray);
      // show sendbackpoints
      this.$store.commit('setSendbackPointsShow', true);
    },
    revertSendback() {
      const _this = this;
      const action = async () => {
        this.updateReportStatus({
          reports: this.elective.reports[0].user2project_id,
          status: 'S'
        }).then(() => {
          if (_this.curDrawerType === 'schedule')
            _this.fetchLessons(_this.lessonOptions);
          else if (_this.curDrawerType === 'student') {
            if (_this.isOrg)
              _this.fetchOrgs(_this.orgOptions).then(data => {
                _this.afterFetchOrgs(data);
              });
            else
              _this.fetchStudents(_this.studentOptions).then(data => {
                _this.afterFetchStudents(data);
              });
          }

          _this.reloadElective();
          _this.reload();
        });
        this.$store.commit('setConfirm', '');
      };
      this.$store.commit('setConfirmAction', action);
      this.$store.commit(
        'setConfirm',
        '确定要撤销吗? 已发送的消息无法撤回, 撤销后请及时批改报告。'
      );
    },
    // 重新批阅
    reCheck() {
      const _this = this;
      const action = async () => {
        let currentElectiveId = this.elective.id;
        this.updateReportStatus({
          reports: this.elective.reports[0].user2project_id,
          status: 'S'
        }).then(() => {
          let target;
          if (this.electives.length === 0) {
            target = this.elective; // Keep current elective if no electives
          } else {
            if (_this.curDrawerType === 'student') {
              if (_this.isOrg) {
                _this.fetchOrgs(_this.orgOptions).then(data => {
                  _this.afterFetchOrgs(data).then(() => {
                    target = _this.electives.reduce((found, group) => {
                      let match = group.electives.find(
                        e => e.id === currentElectiveId
                      );
                      return match || found;
                    }, null);
                    // If not found, keep current elective
                    if (!target) {
                      target = this.elective;
                    }
                    _this.changeElective(target);
                  });
                });
              } else {
                _this.fetchStudents(_this.studentOptions).then(data => {
                  _this.afterFetchStudents(data).then(() => {
                    target = _this.electives.reduce((found, group) => {
                      let match = group.electives.find(
                        e => e.id === currentElectiveId
                      );
                      return match || found;
                    }, null);
                    // If not found, keep current elective
                    if (!target) {
                      target = this.elective;
                    }
                    _this.changeElective(target);
                  });
                });
              }
            } else {
              // Search through all electives groups
              target = this.electives.reduce((found, group) => {
                let match = group.electives.find(
                  e => e.id === currentElectiveId
                );
                return match || found;
              }, null);

              if (!target) {
                target = this.elective;
              }
              _this.changeElective(target);
            }
          }
        });
        this.$store.commit('setConfirm', '');
      };
      this.$store.commit('setConfirmAction', action);
      this.$store.commit(
        'setConfirm',
        '该同学的报告您已经批改, 确定要重新批改吗? '
      );
    },
    checkComplete(mode) {
      if (this.config.autoAlert) {
        let checkedNumber = [];

        for (let i = 0; i < this.reports.length; ++i) {
          if (!this.canvasArray[i] || !this.canvasArray[i].isDrawn)
            checkedNumber.push(i + 1);
        }

        if (checkedNumber.length) {
          switch (mode) {
            case 'saveDraft':
              this.$store.commit('setConfirmAction', () => this.saveDraft());
              this.$store.commit(
                'setConfirm',
                `还有第 ${checkedNumber.toString()} 页报告尚未浏览, 是否执行操作?`
              );
              break;
            case 'submit':
              this.$store.commit('setConfirmAction', () => this.submit());
              this.$store.commit(
                'setConfirm',
                `还有第 ${checkedNumber.toString()} 页报告尚未浏览, 是否执行操作?`
              );
              break;
            case 'quick':
              this.$store.commit('setConfirmAction', () => {
                if (!this.config.quickMode) {
                  this.submit('quick');
                } else {
                  this.saveDraft('quick');
                }
              });
              this.$store.commit(
                'setConfirm',
                `还有第 ${checkedNumber.toString()} 页报告尚未浏览, 是否执行操作?`
              );
              break;
          }
        } else {
          switch (mode) {
            case 'saveDraft':
              this.saveDraft();
              break;
            case 'submit':
              this.submit();
              break;
            case 'quick':
              if (!this.config.quickMode) {
                this.submit('quick');
              } else {
                this.saveDraft('quick');
              }
              break;
          }
        }
      } else {
        switch (mode) {
          case 'saveDraft':
            this.saveDraft();
            break;
          case 'submit':
            this.submit();
            break;
          case 'quick':
            if (!this.config.quickMode) {
              this.submit('quick');
            } else {
              this.saveDraft('quick');
            }
            break;
        }
      }
    },
    saveDraft(mode) {
      const _this = this;
      const quickAction = () => {
        this.uploadCanvas('Draft', '草稿保存成功', mode);
        this.$store.commit('setConfirm', '');
      };

      if (_this.drawType === 'wrong') {
        _this.$store.commit('setHangingDrawdeduction', null);
        _this.changeSelectedItem(null);
      }

      _this.drawType = '';

      let rotated = this.canvasArray.some(x => x.rotateTimes % 4 != 0);

      if (this.config.autoAlert) this.$store.commit('setConfirm', '');

      if (rotated) {
        let rotateTimes = this.canvasArray.map(palette => {
          return palette.rotateTimes;
        });
        this.rotateReport({
          id: this.elective.id,
          rotateTimes: rotateTimes
        }).then(() => {
          if (mode === 'quick') {
            this.$store.commit('setConfirmAction', quickAction);
            this.$store.commit(
              'setConfirm',
              `确定将报告批改成 ${
                this.quickDeduction ? this.quickDeduction : 0
              } 分吗?`
            );
          } else {
            _this.uploadCanvas('Draft', '草稿保存成功');
          }

          _this.updateDrawProcess(true, rotateTimes);
        });
      } else {
        if (mode === 'quick') {
          this.$store.commit('setConfirmAction', quickAction);
          this.$store.commit(
            'setConfirm',
            `确定将报告批改成 ${
              this.quickDeduction ? this.quickDeduction : 0
            } 分吗?`
          );
        } else {
          this.uploadCanvas('Draft', '草稿保存成功');
        }
      }
    },
    // 上传批阅
    uploadCanvas(rpt_status, notice, mode) {
      let _this = this;
      let files = [];
      let processedCount = 0;

      // 处理画布的函数
      const processCanvas = (item, index) => {
        if (typeof item.canvas === 'string') {
          // 如果是序列化的字符串，需要先反序列化为 Canvas 对象
          try {
            const json = JSON.parse(item.canvas);
            const tempCanvas = new fabric.Canvas(null, {
              width: item.width || 800,
              height: item.height || 600
            });
            tempCanvas.loadFromJSON(json, function() {
              tempCanvas.setZoom(item.ratio);
              delete tempCanvas.backgroundImage;
              let h = tempCanvas.getHeight();
              let w = tempCanvas.getWidth();

              if (tempCanvas.getObjects().length == 0 && _this.config.autoCheck) {
                let canvasObject = _this.drawRight(
                  w / 2,
                  h / 2,
                  (w / 8) * _this.coefficient
                );
                tempCanvas.add(canvasObject);
              }

              let url = tempCanvas.toDataURL({
                format: 'png',
                width: w,
                height: h
              });
              url = url.slice(22);
              files[index] = url;
              processedCount++;
              checkComplete();
            });
          } catch (error) {
            console.error('Canvas deserialization failed:', error);
            files[index] = '';
            processedCount++;
            checkComplete();
          }
        } else {
          // 如果是 Canvas 对象，直接处理
          let canvas = item.canvas;
          canvas.setZoom(item.ratio);
          delete canvas.backgroundImage;
          let h = canvas.getHeight();
          let w = canvas.getWidth();

          if (canvas.getObjects().length == 0 && _this.config.autoCheck) {
            let canvasObject = _this.drawRight(
              w / 2,
              h / 2,
              (w / 8) * _this.coefficient
            );
            canvas.add(canvasObject);
          }

          let url = canvas.toDataURL({
            format: 'png',
            width: w,
            height: h
          });
          url = url.slice(22);
          files[index] = url;
          processedCount++;
          checkComplete();
        }
      };

      // 检查是否所有画布都处理完成
      const checkComplete = () => {
        if (processedCount === _this.canvasArray.length) {
          _this.sendReport(rpt_status, notice, mode, files);
        }
      };

      // 如果没有画布数组，直接发送
      if (this.canvasArray.length === 0) {
        _this.sendReport(rpt_status, notice, mode, files);
        return;
      }

      // 初始化 files 数组
      for (let i = 0; i < this.canvasArray.length; i++) {
        files[i] = null;
      }

      // 处理所有画布
      this.canvasArray.forEach((item, index) => {
        processCanvas(item, index);
      });
    },

    // 发送报告的函数
    sendReport(rpt_status, notice, mode, files) {
      this.updateReport({
        id: this.elective.id,
        grade: mode === 'quick' ? this.quickDeduction : this.grade,
        page: this.canvasArray.length,
        student: this.elective.user_id,
        status: rpt_status,
        commitTeacher: this.user.id,
        files: files
      }).then(() => {
        if (this.curDrawerType === 'schedule')
          this.fetchLessons(this.lessonOptions);
        else if (this.curDrawerType === 'student') {
          if (this.isOrg)
            this.fetchOrgs(this.orgOptions).then(data => {
              this.afterFetchOrgs(data);
            });
          else
            this.fetchStudents(this.studentOptions).then(data => {
              this.afterFetchStudents(data);
            });
        }

        this.next();
        this.alert({ message: notice, color: 'success' });
      });
    },
    // 提交批阅
    submit(mode) {
      const _this = this;
      const quickAction = () => {
        this.uploadCanvas('C', '报告提交成功', mode);
        this.$store.commit('setConfirm', '');
      };

      if (_this.drawType === 'wrong') {
        _this.$store.commit('setHangingDrawdeduction', null);
        _this.changeSelectedItem(null);
      }

      _this.drawType = '';

      if (this.elective.reports[0].status === 'Draft') {
        this.updateReportStatus({
          reports: this.elective.id,
          status: 'C'
        }).then(() => {
          if (_this.curDrawerType === 'schedule')
            _this.fetchLessons(_this.lessonOptions);
          else if (_this.curDrawerType === 'student') {
            if (_this.isOrg)
              _this.fetchOrgs(_this.orgOptions).then(data => {
                _this.afterFetchOrgs(data);
              });
            else
              _this.fetchStudents(_this.studentOptions).then(data => {
                _this.afterFetchStudents(data);
              });
          }

          _this.next();
          _this.alert({ message: '报告提交成功', color: 'success' });
        });
      } else {
        const _this = this;
        let rotated = this.canvasArray.some(x => x.rotateTimes % 4 != 0);

        if (this.config.autoAlert) this.$store.commit('setConfirm', '');

        if (rotated) {
          let rotateTimes = this.canvasArray.map(palette => {
            return palette.rotateTimes;
          });
          this.rotateReport({
            id: this.elective.id,
            rotateTimes: rotateTimes
          }).then(() => {
            if (mode === 'quick') {
              this.$store.commit('setConfirmAction', quickAction);
              this.$store.commit(
                'setConfirm',
                `确定将报告批改成 ${
                  this.quickDeduction ? this.quickDeduction : 0
                } 分吗?`
              );
            } else _this.uploadCanvas('C', '报告提交成功');

            _this.updateDrawProcess(true, rotateTimes);
          });
        } else {
          if (mode === 'quick') {
            this.$store.commit('setConfirmAction', quickAction);
            this.$store.commit(
              'setConfirm',
              `确定将报告批改成 ${
                this.quickDeduction ? this.quickDeduction : 0
              } 分吗?`
            );
          } else this.uploadCanvas('C', '报告提交成功');
        }
      }
    },
    // 更新批改记录
    updateDrawProcess(isRotated, rotateTimes) {
      let payload = this.canvasArray.map((item, index) => {
        if (typeof item.canvas === 'string') {
          // 如果是序列化的字符串，直接使用
          const json = JSON.parse(item.canvas);
          if (isRotated && rotateTimes[index] !== 0) {
            return {
              width: item.width,
              height: item.height,
              canvas: item.canvas
            };
          } else if (this.layer_data && this.layer_data[index]) {
            return {
              width: this.layer_data[index].width,
              height: this.layer_data[index].height,
              canvas: item.canvas
            };
          } else {
            return {
              width: item.width,
              height: item.height,
              canvas: item.canvas
            };
          }
        } else {
          // 如果是 Canvas 对象，使用原来的逻辑
          const json = item.canvas.toJSON(['eindex', 'score']);
          if (isRotated && rotateTimes[index] !== 0) {
            return {
              width: item.width,
              height: item.height,
              canvas: JSON.stringify(json)
            };
          } else if (this.layer_data && this.layer_data[index]) {
            return {
              width: this.layer_data[index].width,
              height: this.layer_data[index].height,
              canvas: JSON.stringify(json)
            };
          } else {
            return {
              width: item.width,
              height: item.height,
              canvas: JSON.stringify(json)
            };
          }
        }
      });

      this.deduct(payload);
    },
    // 重绘批改记录
    drawProcess({ index, layer_data, canvas }) {
      // 有批改记录则先重绘批改记录
      if (layer_data && layer_data[index]) {
        canvas.setWidth(layer_data[index].width);
        canvas.setHeight(layer_data[index].height);
        canvas.loadFromJSON(
          layer_data[index].canvas,
          canvas.renderAll.bind(canvas)
        );

        canvas.getObjects('deduction').forEach(item => {
          this.grade += item.score;
          this.deductScores[index] += item.score;
        });

        this.drawBackground({
          index,
          canvas,
          width: layer_data[index].width
        });
        // 无批改记录则直接加载当前报告纸
      } else {
        this.drawBackground({ index, canvas });
      }
    },
    // 重绘批改记录后添加报告纸
    drawBackground({ index, canvas, width }) {
      fabric.Image.fromURL(
        this.reports[index],
        img => {
          let clientWidth = this.screenWidth;
          let clientHeight = this.screenHeight;
          let screenAspectRadio = clientWidth / clientHeight;
          let imageAspectRatio = img.width / img.height;
          let renderWidth, renderHeight;
          if (imageAspectRatio < screenAspectRadio) {
            renderHeight = clientHeight;
            renderWidth = img.width * (renderHeight / img.height);
          } else if (imageAspectRatio > screenAspectRadio) {
            renderWidth = clientWidth;
            renderHeight = img.height * (renderWidth / img.width);
          } else {
            renderWidth = img.width;
            renderHeight = img.height;
          }

          if (width) {
            canvas.setZoom(renderWidth / width);
            img.scaleToWidth(renderWidth / (renderWidth / width));
            img.scaleToHeight(renderHeight / (renderWidth / width));

            this.canvasArray[index] = {
              isDrawn: canvas.getObjects().length ? true : false,
              width: renderWidth,
              height: renderHeight,
              originalRatio: renderWidth / width,
              ratio: renderWidth / width,
              rotateTimes: 0,
              canvas: canvas
            };
          } else {
            img.scaleToWidth(renderWidth);
            img.scaleToHeight(renderHeight);
            this.canvasArray[index] = {
              isDrawn: false,
              width: renderWidth,
              height: renderHeight,
              originalRatio: 1,
              ratio: 1,
              rotateTimes: 0,
              canvas: canvas
            };
          }

          canvas.setWidth(renderWidth);
          canvas.setHeight(renderHeight);

          img.excludeFromExport = true;
          canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));

          // 用于撤销或撤回后重新加载背景图片
          this.backgroundImages[index] = img;

          let canvasItem = document.querySelector(`#canvas-${index}`);
          let carouselItem = canvasItem.parentNode.parentNode;
          carouselItem.style =
            'display:flex; justify-content:center; align-items:center; flex-wrap: wrap;';

          this.$set(this.loadings, index, false);
          ++this.counts;

          if (this.counts === this.reports.length) this.showGrade = true;
        },
        {
          crossOrigin: 'anonymous'
        }
      );
    },
    // 图片操作
    drawClick(drawType) {
      let menu = document.querySelector('.menu_style');

      if (menu.style.visibility === 'visible') {
        menu.style = 'visibility: hidden; width: 300px;';
      }

      this.drawType = drawType;
      let canvas = this.canvasArray[this.carouselIndex].canvas;

      if (drawType === 'pen') canvas.isDrawingMode = true;
      else canvas.isDrawingMode = false;

      canvas.selection = false;
      canvas.skipTargetFind = true;

      if (drawType !== 'wrong') {
        this.$store.commit('setHangingDrawdeduction', null);
        this.changeSelectedItem(null);
      }

      if (this.textblock) {
        this.textblock.exitEditing();
        this.textblock = null;
        canvas.skipTargetFind = true;
      }

      if (drawType === 'remove') {
        canvas.selection = true;
        canvas.skipTargetFind = false;
        canvas.getObjects().forEach(item => (item.selectable = true));
      } else {
        canvas.selection = false;
        canvas.skipTargetFind = true;
        canvas.getObjects().forEach(item => (item.selectable = false));
      }
    },
    drawing() {
      let _this = this;
      this.isSubmit = false;
      let canvas = this.canvasArray[this.carouselIndex].canvas;
      canvas.isDrawingMode = false;
      let canvasObject = null;

      if (this.drawingObject) {
        canvas.remove(this.drawingObject);
      }

      if (this.drawingItext) {
        canvas.remove(this.drawingItext);
      }

      switch (this.drawType) {
        case 'pen':
          canvas.isDrawingMode = true;
          break;
        case 'right':
          canvasObject = this.drawRight(
            this.mouseFrom.x,
            this.mouseFrom.y,
            100 * this.coefficient
          );
          break;
        case 'halfError':
          canvasObject = this.drawHalfError(this.mouseFrom.x, this.mouseFrom.y);
          break;
        case 'error':
          canvasObject = this.drawWrong(
            this.mouseFrom.x,
            this.mouseFrom.y,
            25 * this.coefficient,
            false
          );
          break;
        case 'wrong':
          if (
            this.hangingDrawdeduction.check_mark != 'right' &&
            this.erade + _this.hangingDrawdeduction.score < 0
          ) {
            this.alert({ message: '分数小于0,不可以继续扣分', color: 'error' });
          } else {
            let errMark = '',
              color = '';

            if (this.hangingDrawdeduction.check_mark === 'right') {
              errMark = this.drawRight(
                this.mouseFrom.x,
                this.mouseFrom.y,
                30 * this.coefficient,
                true
              );

              color = this.hangingDrawdeduction.color
                ? this.hangingDrawdeduction.color
                : '#008B00';
            } else if (this.hangingDrawdeduction.check_mark === 'half_error') {
              errMark = this.drawHalfError(
                this.mouseFrom.x,
                this.mouseFrom.y,
                true
              );

              color = this.hangingDrawdeduction.color
                ? this.hangingDrawdeduction.color
                : '#FF0000';
            } else {
              errMark = this.drawWrong(
                this.mouseFrom.x,
                this.mouseFrom.y,
                25 * this.coefficient,
                true
              );

              color = this.hangingDrawdeduction.color
                ? this.hangingDrawdeduction.color
                : '#FF0000';
            }

            let x = this.mouseFrom.x;
            let y = this.mouseFrom.y;
            let str = '';
            let h = 1;

            // 判断是否 '批改时隐藏给学生的评语'
            if (!this.hangingDrawdeduction.hide_comment) {
              for (
                let i = 0;
                i < this.hangingDrawdeduction.comment.length;
                i++
              ) {
                if (i % 10 == 0) {
                  str += '\n';
                  h++;
                }

                str += this.hangingDrawdeduction.comment[i];

                if (
                  this.canvasArray[this.carouselIndex].canvas.getWidth() -
                    this.mouseFrom.x <
                  (str.length < 10 ? str.length : 10) * 35 * this.coefficient
                ) {
                  x =
                    this.canvasArray[this.carouselIndex].canvas.getWidth() -
                    (str.length < 10 ? str.length : 10) * 35 * this.coefficient;
                }
              }
            }

            // 判断是否 '批改时隐藏分值'
            if (!this.hangingDrawdeduction.hide_score) {
              // 当批改时隐藏给学生的评语时, 调节分值与对错标记的间距
              if (this.hangingDrawdeduction.score > 0) {
                if (this.hangingDrawdeduction.hide_comment) {
                  str += '\n+' + this.hangingDrawdeduction.score;

                  if (
                    this.canvasArray[this.carouselIndex].canvas.getWidth() -
                      this.mouseFrom.x <
                    this.hangingDrawdeduction.score.toString().length *
                      35 *
                      this.coefficient
                  ) {
                    x =
                      this.canvasArray[this.carouselIndex].canvas.getWidth() -
                      (this.hangingDrawdeduction.score.toString().length + 1) *
                        35 *
                        this.coefficient;
                  }
                } else str += '\n+' + this.hangingDrawdeduction.score;
              } else if (this.hangingDrawdeduction.score < 0) {
                if (this.hangingDrawdeduction.hide_comment) {
                  str += '\n' + this.hangingDrawdeduction.score;

                  if (
                    this.canvasArray[this.carouselIndex].canvas.getWidth() -
                      this.mouseFrom.x <
                    this.hangingDrawdeduction.score.toString().length *
                      35 *
                      this.coefficient
                  ) {
                    x =
                      this.canvasArray[this.carouselIndex].canvas.getWidth() -
                      this.hangingDrawdeduction.score.toString().length *
                        35 *
                        this.coefficient;
                  }
                } else str += '\n' + this.hangingDrawdeduction.score;
              }
            }

            if (
              this.canvasArray[this.carouselIndex].canvas.getHeight() - y <
              h * 35 * this.coefficient
            )
              y =
                this.canvasArray[this.carouselIndex].canvas.getHeight() -
                h * 35 * this.coefficient;

            let text = new fabric.Text(str, {
              left: x + 12 * this.coefficient,
              top: y - 40 * this.coefficient,
              fontSize: 28 * this.coefficient,
              borderColor: '#2c2c2c',
              fill: color,
              hasControls: false,
              type: 'textbox'
            });
            canvasObject = new fabric.Deduction([errMark, text], {
              eindex: this.hangingDrawdeduction.id,
              score: this.hangingDrawdeduction.score
            });
          }
          break;
        case 'smallright':
          canvasObject = this.drawRight(
            this.mouseFrom.x,
            this.mouseFrom.y,
            50 * this.coefficient
          );
          break;
        case 'line':
          canvasObject = this.drawLine(
            this.mouseFrom.x,
            this.mouseFrom.y,
            this.mouseTo.x,
            this.mouseTo.y
          );
          break;
        case 'arrow':
          canvasObject = this.drawArrow(
            this.mouseFrom.x,
            this.mouseFrom.y,
            this.mouseTo.x,
            this.mouseTo.y
          );
          break;
        case 'rectangle':
          canvasObject = this.drawRectangle(
            this.mouseFrom.x,
            this.mouseFrom.y,
            this.mouseTo.x,
            this.mouseTo.y
          );
          break;
        case 'ellipse':
          canvasObject = this.drawEllipse(
            this.mouseFrom.x,
            this.mouseFrom.y,
            this.mouseTo.x,
            this.mouseTo.y
          );
          break;
        case 'triangle':
          canvasObject = this.drawTriangle(
            this.mouseFrom.x,
            this.mouseFrom.y,
            this.mouseTo.x,
            this.mouseTo.y
          );
          break;
        case 'questionmark':
          canvasObject = this.drawQuestionMark(
            this.mouseFrom.x,
            this.mouseFrom.y
          );
          break;
        case 'text':
          {
            canvas.skipTargetFind = false;
            canvas.selection = true;
            let itext = new fabric.IText('', {
              left: this.mouseFrom.x,
              top: this.mouseFrom.y,
              fill: this.shapeColor,
              fontSize: 30 * this.coefficient
            });

            canvas.add(itext);
            this.drawType = '';
            itext.selectable = true;
            itext.enterEditing();
            this.textblock = itext;
          }
          break;
        case 'appendMark':
          {
            const { x, y, originX, o } = this.drawAppend(
              this.mouseFrom.x,
              this.mouseFrom.y,
              this.mouseTo.x,
              this.mouseTo.y
            );

            canvasObject = o;

            let itext = new fabric.IText('添加文本', {
              left: x,
              top: y,
              originX,
              originY: 'center',
              fill: '#FF0000',
              fontSize: 30 * this.coefficient,
              backgroundColor: '#F0808033'
            });
            this.drawingItext = itext;

            canvas.add(itext);
            itext.enterEditing();
            this.textblock = itext;
          }
          break;
        case 'removeMark':
          canvasObject = this.drawRemove(
            this.mouseFrom.x,
            this.mouseFrom.y,
            this.mouseTo.x,
            this.mouseTo.y
          );
          break;
        case 'remove':
          break;
        default:
          break;
      }

      if (canvasObject) {
        this.drawingObject = canvasObject;

        if (this.drawType == 'wrong') {
          this.grade += canvasObject.score;
          this.deductScores[this.carouselIndex] += canvasObject.score;
          this.addDeductionHistory(); // 记录评分参考历史
        }

        canvas.add(canvasObject);
      }
    },
    drawHalfError(x, y, isDeduction) {
      let path =
        'M ' +
        (x - 25 * this.coefficient) +
        ' ' +
        (y - 25 * this.coefficient) +
        ' L ' +
        x +
        ' ' +
        y +
        ' L ' +
        (x + 25 * 2 * this.coefficient) +
        ' ' +
        (y - 25 * 2 * this.coefficient) +
        'M ' +
        (x + 15 * this.coefficient) +
        ' ' +
        (y - 40 * this.coefficient) +
        ' L ' +
        (x + 40 * this.coefficient) +
        ' ' +
        (y - 15 * this.coefficient);

      if (isDeduction) {
        return new fabric.Path(path, {
          stroke: this.hangingDrawdeduction.color
            ? this.hangingDrawdeduction.color
            : '#FF0000',
          strokeWidth: 3 * this.coefficient,
          fill: 'rgba(255, 255, 255, 0)'
        });
      } else {
        return new fabric.Path(path, {
          stroke: this.shapeColor,
          strokeWidth: 3 * this.coefficient,
          fill: 'rgba(255, 255, 255, 0)'
        });
      }
    },
    drawWrong(x, y, size, isDeduction) {
      let path =
        'M ' +
        (x - size) +
        ' ' +
        (y - size) +
        ' L ' +
        (x + size) +
        ' ' +
        (y + size) +
        'M ' +
        (x + size) +
        ' ' +
        (y - size) +
        ' L ' +
        (x - size) +
        ' ' +
        (y + size);

      if (isDeduction) {
        return new fabric.Path(path, {
          stroke: this.hangingDrawdeduction.color
            ? this.hangingDrawdeduction.color
            : '#FF0000',
          strokeWidth: 3 * this.coefficient,
          fill: 'rgba(255, 255, 255, 0)'
        });
      } else {
        return new fabric.Path(path, {
          stroke: this.shapeColor,
          strokeWidth: 3 * this.coefficient,
          fill: 'rgba(255, 255, 255, 0)'
        });
      }
    },
    drawRight(x, y, size, isDeduction) {
      let path =
        'M ' +
        (x - size) +
        ' ' +
        (y - size) +
        ' L ' +
        x +
        ' ' +
        y +
        ' L ' +
        (x + size * 2) +
        ' ' +
        (y - size * 2);

      if (isDeduction) {
        return new fabric.Path(path, {
          stroke: this.hangingDrawdeduction.color
            ? this.hangingDrawdeduction.color
            : '#008B00',
          strokeWidth: 3 * this.coefficient,
          eindex: 0,
          fill: 'rgba(255, 255, 255, 0)'
        });
      } else {
        return new fabric.Path(path, {
          stroke: this.shapeColor,
          strokeWidth: 3 * this.coefficient,
          eindex: 0,
          fill: 'rgba(255, 255, 255, 0)'
        });
      }
    },
    drawLine(x, y, mx, my) {
      return new fabric.Line([x, y, mx, my], {
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255, 255, 255, 0)'
      });
    },
    drawArrow(x, y, mx, my) {
      let angle = (Math.atan2(y - my, x - mx) * 180) / Math.PI;
      let angle1 = ((angle + 20) * Math.PI) / 180;
      let angle2 = ((angle - 20) * Math.PI) / 180;
      let topX = 10 * Math.cos(angle1);
      let topY = 10 * Math.sin(angle1);
      let botX = 10 * Math.cos(angle2);
      let botY = 10 * Math.sin(angle2);
      let arrowX = x - topX;
      let arrowY = y - topY;
      let path = ' M ' + x + ' ' + y;
      path += ' L ' + mx + ' ' + my;
      arrowX = mx + topX;
      arrowY = my + topY;
      path += ' M ' + arrowX + ' ' + arrowY;
      path += ' L ' + mx + ' ' + my;
      arrowX = mx + botX;
      arrowY = my + botY;
      path += ' L ' + arrowX + ' ' + arrowY;

      return new fabric.Path(path, {
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255, 255, 255, 0)'
      });
    },
    drawRectangle(x, y, mx, my) {
      return new fabric.Rect({
        top: y,
        left: x,
        width: mx - x,
        height: my - y,
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255, 255, 255, 0)'
      });
    },
    drawEllipse(x, y, mx, my) {
      return new fabric.Ellipse({
        top: y,
        left: x,
        rx: Math.abs(mx - x),
        ry: Math.abs(my - y),
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255, 255, 255, 0)'
      });
    },
    drawTriangle(x, y, mx, my) {
      return new fabric.Triangle({
        top: y,
        left: x,
        width: mx - x,
        height: my - y,
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255,255,255,0)'
      });
    },
    drawAppend(x, y, mx, my) {
      let qx, qy, originX, path;

      if (x > mx && y > my) {
        qx = -15;
        qy = -15;
        originX = 'right';
        path = `M ${x} ${y} L ${x - 5} ${y + 5} M ${x} ${y} L ${x + 5} ${y +
          5} M ${x} ${y} L ${x} ${my} Q ${x} ${my + qy}, ${x + qx} ${my +
          qy} L ${mx} ${my + qy}`;
      } else if (x < mx && y > my) {
        qx = 15;
        qy = -15;
        originX = 'left';
        path = `M ${x} ${y} L ${x - 5} ${y + 5} M ${x} ${y} L ${x + 5} ${y +
          5} M ${x} ${y} L ${x} ${my} Q ${x} ${my + qy}, ${x + qx} ${my +
          qy} L ${mx} ${my + qy}`;
      } else if (x < mx && y < my) {
        qx = 15;
        qy = 15;
        originX = 'left';
        path = `M ${x} ${y} L ${x - 5} ${y - 5} M ${x} ${y} L ${x + 5} ${y -
          5} M ${x} ${y} L ${x} ${my} Q ${x} ${my + qy}, ${x + qx} ${my +
          qy} L ${mx} ${my + qy}`;
      } else if (x > mx && y < my) {
        qx = -15;
        qy = 15;
        originX = 'right';
        path = `M ${x} ${y} L ${x - 5} ${y - 5} M ${x} ${y} L ${x + 5} ${y -
          5} M ${x} ${y} L ${x} ${my} Q ${x} ${my + qy}, ${x + qx} ${my +
          qy} L ${mx} ${my + qy}`;
      }

      return {
        x: mx,
        y: my + qy,
        originX,
        o: new fabric.Path(path, {
          stroke: '#FF0000',
          strokeWidth: 3 * this.coefficient,
          fill: 'rgba(255, 255, 255, 0)'
        })
      };
    },
    drawRemove(x, y, mx, my) {
      let tail;

      if (x > mx && y > my) {
        const qx1 = -5,
          qy1 = -10,
          qx2 = qx1 - 10,
          qy2 = qy1 - 5,
          qx3 = qx2 - 10,
          qy3 = qy2 - 5,
          ax = -5,
          ay = 5;

        tail = `M ${mx} ${my} C ${mx} ${my}, ${mx} ${my - 5}, ${mx + qx1} ${my +
          qy1} A 2.5 2.5 0 0 0 ${mx + qx1 + ax} ${my +
          qy1 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx1} ${my + qy1} C ${mx + qx1} ${my +
          qy1}, ${mx + qx1 - 5} ${my + qy1 - 5}, ${mx + qx2} ${my +
          qy2} A 2.5 2.5 0 0 0 ${mx + qx2 + ax} ${my +
          qy2 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx2} ${my + qy2} C ${mx + qx2} ${my +
          qy2}, ${mx + qx2 - 5} ${my + qy2 - 5}, ${mx + qx3} ${my + qy3}`;
      } else if (x < mx && y > my) {
        const qx1 = 5,
          qy1 = -10,
          qx2 = qx1 + 10,
          qy2 = qy1 - 5,
          qx3 = qx2 + 10,
          qy3 = qy2 - 5,
          ax = 5,
          ay = 5;

        tail = `M ${mx} ${my} C ${mx} ${my}, ${mx} ${my - 5}, ${mx + qx1} ${my +
          qy1} A 2.5 2.5 0 0 0 ${mx + qx1 + ax} ${my +
          qy1 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx1} ${my + qy1} C ${mx + qx1} ${my +
          qy1}, ${mx + qx1 + 5} ${my + qy1 - 5}, ${mx + qx2} ${my +
          qy2} A 2.5 2.5 0 0 0 ${mx + qx2 + ax} ${my +
          qy2 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx2} ${my + qy2} C ${mx + qx2} ${my +
          qy2}, ${mx + qx2 + 5} ${my + qy2 - 5}, ${mx + qx3} ${my + qy3}`;
      } else if (x < mx && y < my) {
        const qx1 = 5,
          qy1 = 10,
          qx2 = qx1 + 10,
          qy2 = qy1 + 5,
          qx3 = qx2 + 10,
          qy3 = qy2 + 5,
          ax = 5,
          ay = -5;

        tail = `M ${mx} ${my} C ${mx} ${my}, ${mx} ${my + 5}, ${mx + qx1} ${my +
          qy1} A 2.5 2.5 0 0 0 ${mx + qx1 + ax} ${my +
          qy1 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx1} ${my + qy1} C ${mx + qx1} ${my +
          qy1}, ${mx + qx1 + 5} ${my + qy1 + 5}, ${mx + qx2} ${my +
          qy2} A 2.5 2.5 0 0 0 ${mx + qx2 + ax} ${my +
          qy2 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx2} ${my + qy2} C ${mx + qx2} ${my +
          qy2}, ${mx + qx2 + 5} ${my + qy2 + 5}, ${mx + qx3} ${my + qy3}`;
      } else if (x > mx && y < my) {
        const qx1 = -5,
          qy1 = 10,
          qx2 = qx1 - 10,
          qy2 = qy1 + 5,
          qx3 = qx2 - 10,
          qy3 = qy2 + 5,
          ax = -5,
          ay = -5;

        tail = `M ${mx} ${my} C ${mx} ${my}, ${mx} ${my + 5}, ${mx + qx1} ${my +
          qy1} A 2.5 2.5 0 0 0 ${mx + qx1 + ax} ${my +
          qy1 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx1} ${my + qy1} C ${mx + qx1} ${my +
          qy1}, ${mx + qx1 - 5} ${my + qy1 + 5}, ${mx + qx2} ${my +
          qy2} A 2.5 2.5 0 0 0 ${mx + qx2 + ax} ${my +
          qy2 +
          ay} A 2.5 2.5 0 0 0 ${mx + qx2} ${my + qy2} C ${mx + qx2} ${my +
          qy2}, ${mx + qx2 - 5} ${my + qy2 + 5}, ${mx + qx3} ${my + qy3}`;
      }

      const path = `M ${x} ${y} A ${(mx - x) / 2} ${(my - y) /
        2} 0 0 0 ${mx} ${my} A ${(mx - x) / 2} ${(my - y) /
        2} 0 0 0 ${x} ${y} ${tail}`;

      return new fabric.Path(path, {
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255, 255, 255, 0)'
      });
    },
    drawQuestionMark(x, y) {
      const path = `M ${x} ${y} C ${x} ${y - 20} ${x + 10} ${y - 30} ${x +
        25} ${y - 30} C ${x + 40} ${y - 30} ${x + 50} ${y - 20} ${x +
        50} ${y} C ${x + 50} ${y + 15} ${x + 30} ${y + 25} ${x + 25} ${y +
        35} M ${x + 25} ${y + 45} L ${x + 25} ${y + 60}`;

      return new fabric.Path(path, {
        stroke: this.shapeColor,
        strokeWidth: 4 * this.coefficient,
        fill: 'rgba(255, 255, 255, 0)'
      });
    },
    setColor(color) {
      if (color === 'close') this.showColorPicker = false;
      else this.shapeColor = color;
    },
    toggleColorPicker() {
      let menu = document.querySelector('.menu_style');

      if (menu.style.visibility === 'visible') {
        menu.style = 'visibility: hidden; width: 300px;';
      }

      this.showColorPicker = !this.showColorPicker;
    },
    removeAll() {
      this.$store.commit('setConfirmAction', () => {
        this.$store.commit('setConfirm', '');

        for (let i = 0; i < this.reports.length; i++) {
          this.grade -= this.deductScores[i];
          this.deductScores[i] = 0;

          while (this.canvasArray[i].canvas.getObjects().length > 0) {
            this.canvasArray[i].canvas.remove(
              this.canvasArray[i].canvas.getObjects()[0]
            );
          }
        }

        this.updateDrawProcess();
      });
      this.$store.commit('setConfirm', '将清除整个报告的批阅记录, 是否继续? ');
    },
    fix() {
      const screenAspectRadio = this.screenWidth / this.screenHeight;
      let palette = this.canvasArray[this.carouselIndex];
      let imageWidth = palette.canvas.backgroundImage.width;
      let imageHeight = palette.canvas.backgroundImage.height;
      let renderWidth, renderHeight;

      if (palette.rotateTimes % 4 == 1 || palette.rotateTimes % 4 == 3) {
        [imageWidth, imageHeight] = [imageHeight, imageWidth];
      }

      let imageAspectRatio = imageWidth / imageHeight;
      if (imageAspectRatio < screenAspectRadio) {
        renderHeight = this.screenHeight;
        renderWidth = imageWidth * (renderHeight / imageHeight);
      } else if (imageAspectRatio > screenAspectRadio) {
        renderWidth = this.screenWidth;
        renderHeight = imageHeight * (renderWidth / imageWidth);
      } else {
        renderWidth = imageWidth;
        renderHeight = imageHeight;
      }

      if (palette.originalRatio === 1) {
        palette.canvas.setZoom(1);
        palette.ratio = 1;
      } else {
        palette.canvas.setZoom(palette.originalRatio);
        palette.ratio = palette.originalRatio;
      }

      palette.canvas.setHeight(renderHeight);
      palette.canvas.setWidth(renderWidth);

      return { w: renderWidth, h: renderHeight };
    },
    historyFallback() {
      const canvas = this.canvasArray[this.carouselIndex].canvas;

      if (!canvas.backgroundImage) {
        const img = this.backgroundImages[this.carouselIndex];
        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
        this.updateDrawProcess();
      }
    },
    undo() {
      const palette = this.canvasArray[this.carouselIndex];
      const oldGrade = palette.canvas
        .getObjects()
        .filter(item => !!item.eindex)
        .reduce((acc, cur) => acc + cur.score, 0);
      palette.canvas.undo(this.historyFallback);
      const newGrade = palette.canvas
        .getObjects()
        .filter(item => !!item.eindex)
        .reduce((acc, cur) => acc + cur.score, 0);
      if (oldGrade !== newGrade) {
        this.grade += newGrade - oldGrade;
      }
    },
    redo() {
      const palette = this.canvasArray[this.carouselIndex];
      const oldGrade = palette.canvas
        .getObjects()
        .filter(item => !!item.eindex)
        .reduce((acc, cur) => acc + cur.score, 0);
      palette.canvas.redo(this.historyFallback);
      const newGrade = palette.canvas
        .getObjects()
        .filter(item => !!item.eindex)
        .reduce((acc, cur) => acc + cur.score, 0);
      if (oldGrade !== newGrade) {
        this.grade += newGrade - oldGrade;
      }
    },
    zoom(ratio) {
      let palette = this.canvasArray[this.carouselIndex];
      let wrapper = document.querySelector('#wrapper');
      let wrapperWidth = wrapper.clientWidth;
      let canvasWidth = palette.canvas.getWidth();
      let canvasHeight = palette.canvas.getHeight();
      let imageWidth = this.canvasArray[this.carouselIndex].canvas
        .backgroundImage.width;
      let imageHeight = this.canvasArray[this.carouselIndex].canvas
        .backgroundImage.height;

      if (palette.rotateTimes % 4 == 1 || palette.rotateTimes % 4 == 3) {
        [imageWidth, imageHeight] = [imageHeight, imageWidth];
      }

      if (ratio > 0) {
        if (canvasWidth < wrapperWidth && wrapperWidth < imageWidth) {
          // 判断是否根据批阅记录的宽高已经做过缩放
          palette.ratio =
            palette.originalRatio === 1
              ? wrapperWidth / canvasWidth
              : (wrapperWidth / canvasWidth) * palette.originalRatio;
          palette.canvas.setZoom(palette.ratio);
          palette.canvas.setHeight(canvasHeight * palette.ratio);
          palette.canvas.setWidth(wrapperWidth);
        } else if (canvasWidth < imageWidth) {
          palette.ratio =
            palette.originalRatio === 1
              ? imageWidth / palette.width
              : (imageWidth / palette.width) * palette.originalRatio;
          palette.canvas.setZoom(palette.ratio);
          palette.canvas.setHeight(imageHeight);
          palette.canvas.setWidth(imageWidth);
        }
      } else if (
        ratio < 0 &&
        (canvasWidth === wrapperWidth || canvasWidth === imageWidth)
      ) {
        this.fix();
      }
    },
    /**
     * 当前画布为初始尺寸时, 旋转后的图像按显示区宽高比计算适配显示；
     * 放大后的画布只交换宽高, 按照当前画布尺寸显示
     */
    rotate() {
      let _this = this;
      let palette = this.canvasArray[this.carouselIndex];
      let canvas = this.canvasArray[this.carouselIndex].canvas;
      const action = () => {
        this.$store.commit('setConfirm', '');

        palette.rotateTimes++;
        if (_this.deductScores[_this.carouselIndex] !== 0) {
          _this.grade -= _this.deductScores[_this.carouselIndex];
          _this.deductScores[_this.carouselIndex] = 0;
        }

        while (palette.canvas.getObjects().length > 0) {
          palette.canvas.remove(palette.canvas.getObjects()[0]);
        }

        let image = palette.canvas.backgroundImage;
        let imageWidth = image.width;
        let imageHeight = image.height;
        let canvasWidth = palette.canvas.getWidth();
        let canvasHeight = palette.canvas.getHeight();
        let needFix = imageWidth !== canvasWidth;

        [imageWidth, imageHeight] = [imageHeight, imageWidth];
        [canvasWidth, canvasHeight] = [canvasHeight, canvasWidth];

        if (palette.rotateTimes % 4 == 1 || palette.rotateTimes % 4 == 3) {
          needFix = imageWidth !== canvasHeight;
        }

        image.rotate((90 * palette.rotateTimes) % 360);

        if (imageWidth !== canvasWidth) {
          image.scaleToWidth(canvasWidth);
          image.scaleToHeight(canvasHeight);
        }

        if (palette.rotateTimes % 4 == 1) {
          image.top = 0;
          image.left = canvasWidth / palette.originalRatio;
          canvas.setWidth(canvasWidth);
          canvas.setHeight(canvasHeight);
        } else if (palette.rotateTimes % 4 == 2) {
          canvas.setWidth(canvasWidth);
          canvas.setHeight(canvasHeight);
          image.top = canvasHeight / palette.originalRatio;
          image.left = canvasWidth / palette.originalRatio;
        } else if (palette.rotateTimes % 4 == 3) {
          canvas.setWidth(canvasWidth);
          canvas.setHeight(canvasHeight);
          image.top = canvasHeight / palette.originalRatio;
          image.left = 0;
        } else {
          canvas.setWidth(canvasWidth);
          canvas.setHeight(canvasHeight);
          image.top = 0;
          image.left = 0;
        }

        if (needFix) {
          let fixPoint = this.fix();
          image.scaleToWidth(fixPoint.w);
          image.scaleToHeight(fixPoint.h);
          if (palette.rotateTimes % 4 == 1) {
            image.top = 0;
            image.left = fixPoint.w / palette.originalRatio;
            canvas.setWidth(fixPoint.w);
            canvas.setHeight(fixPoint.h);
          } else if (palette.rotateTimes % 4 == 2) {
            canvas.setWidth(fixPoint.w);
            canvas.setHeight(fixPoint.h);
            image.top = fixPoint.h / palette.originalRatio;
            image.left = fixPoint.w / palette.originalRatio;
          } else if (palette.rotateTimes % 4 == 3) {
            canvas.setWidth(fixPoint.w);
            canvas.setHeight(fixPoint.h);
            image.top = fixPoint.h / palette.originalRatio;
            image.left = 0;
          } else {
            canvas.setWidth(fixPoint.w);
            canvas.setHeight(fixPoint.h);
            image.top = 0;
            image.left = 0;
          }
        }

        canvas.clearHistory();
        this.canvasArray[this.carouselIndex].width = canvas.width;
        this.canvasArray[this.carouselIndex].height = canvas.height;
        this.backgroundImages[this.carouselIndex] = image;
      };

      if (canvas.getObjects().length > 0) {
        this.$store.commit('setConfirmAction', action);
        this.$store.commit('setConfirm', '旋转后需要重新批改本页, 是否继续? ');
      } else {
        action();
      }
    },
    calculateDistance(a, b) {
      return Math.sqrt(
        Math.pow(b.pageX - a.pageX, 2) + Math.pow(b.pageY - a.pageY, 2)
      );
    },
    setHistory() {
      this.changeElective(this.histories[this.curNum].user2projects);
      this.selectLessons([
        this.histories[this.curNum].user2projects.check_schedules
      ]);
    },
    viewHistory() {
      api.getHistories(
        this.user.id,
        this.limit,
        this.offset,
        res => {
          if (res.length) {
            this.$store.commit('setHistories', res);
            this.$store.commit('setOriginalU2p', this.elective);
            this.$store.commit('setOriginalSchedule', this.selectedLessons);
            this.setHistory();
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    fetchHistory() {
      api.getHistories(
        this.user.id,
        this.limit,
        this.offset,
        res => {
          if (res.length) {
            this.$store.commit('setCurNum', 0);
            this.$store.commit('setHistories', res);
            this.setHistory();
          } else {
            this.$store.commit('setCurNum', this.curNum - 1);
            this.$store.commit('setEnding', true);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    previousHistory() {
      if (this.ending) this.$store.commit('setEnding', false);

      if (this.curNum > 0) {
        this.$store.commit('setCurNum', this.curNum - 1);
        this.setHistory();
      } else {
        this.$store.commit('setOffset', this.offset - this.limit);
        this.fetchHistory();
      }
    },
    nextHistory() {
      if (
        (this.histories.length < this.limit &&
          this.curNum < this.histories.length - 1) ||
        this.curNum < this.limit - 1
      ) {
        this.$store.commit('setCurNum', this.curNum + 1);
        this.setHistory();

        if (
          this.histories.length < this.limit &&
          this.curNum === this.histories.length - 1
        )
          this.$store.commit('setEnding', true);
      } else {
        this.$store.commit('setOffset', this.offset + this.limit);
        this.fetchHistory();
      }
    },
    quitHistory() {
      this.changeElective(this.originalU2p);
      this.selectLessons(this.originalSchedule);

      setTimeout(() => {
        this.$store.commit('setHistories', []);
        this.$store.commit('setOriginalU2p', null);
        this.$store.commit('setOriginalSchedule', null);
        this.$store.commit('setCurNum', 0);
        this.$store.commit('setOffset', 0);
        this.$store.commit('setEnding', false);
      }, 500);
    },
    // 获取画布对象，如果是序列化的则反序列化
    getCanvas(index) {
      const item = this.canvasArray[index];
      if (!item) return null;

      if (typeof item.canvas === 'string') {
        // 如果是序列化的字符串，需要反序列化
        try {
          const canvas = new fabric.Canvas(`canvas-${index}`, {
            crossOrigin: 'anonymous',
            isDrawingMode: false,
            skipTargetFind: true,
            selection: false,
            fireRightClick: true,
            stopContextMenu: true,
            allowTouchScrolling: true,
            originX: 'left',
            originY: 'top'
          });

          const json = JSON.parse(item.canvas);
          canvas.loadFromJSON(json, () => {
            canvas.renderAll();
          });

          // 更新 canvasArray 中的 canvas 对象
          this.$set(this.canvasArray, index, {
            ...item,
            canvas: canvas
          });

          return canvas;
        } catch (error) {
          console.error('Canvas deserialization failed:', error);
          return null;
        }
      }

      return item.canvas;
    }
  }
};
</script>
